export function cleanAreaData(data) {
    const firstElement = data?.raw[0]
    return data?.raw.reduce( (acc,x) => {
        const json = JSON.parse(x)
        const comma = firstElement === x ? '' : ', '
        // Hay llaves con tildes
        for (let key in json) {
            acc = acc.concat(comma, json[key].trim())
        }
        return acc
    },'')
}

export function cleanStandardData(data) {
    console.log("data:"+data)
    const firstElement = data?.raw[0]
    return data?.raw.reduce( (acc,x) => {
        const json = JSON.parse(x)
        const comma = firstElement === x ? '' : ', '
        // Hay llaves con tildes
        for (let key in json) {
            acc = acc.concat(comma, json[key])
        }
        return acc
    },'')
}